import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import React, { useRef } from 'react';

import { Upload } from 'react-feather';
import { convertPdfToImages } from '../../common/PDFResolver';
import { useTranslation } from 'react-i18next';

function UploadButton({ disabled, setUploadedFileName, setShowDiagram }) {
  const { t } = useTranslation();
  const inputRef = useRef();

  const handleUpload = () => {
    inputRef.current?.click();
  };

  const handleDisplayFileDetails = (e) => {
    inputRef.current?.files &&
      setUploadedFileName(inputRef.current.files[0].name);

    setShowDiagram(false);
    const file = e.target.files[0];

    if (file.type !== 'application/pdf') {
      let resolver = () => {};
      let reader = new FileReader();

      reader.onload = function (e) {
        let img = document.createElement('img');

        img.onload = function (event) {
          const sizeW = img.width,
            sizeH = img.height;

          // Dynamically create a canvas element
          let canvas = document.createElement('canvas');
          canvas.width = sizeW;
          canvas.height = sizeH;

          let ctx = canvas.getContext('2d');

          // Actual resizing
          ctx.drawImage(img, 0, 0, sizeW, sizeH);

          // Show resized image in preview element
          let dataurl = canvas.toDataURL(file.type);

          resolver(dataurl);
          setUploadedFileName(dataurl);
        };
        img.src = e.target.result;
      };

      reader.readAsDataURL(file);
    } else {
      let resolver = () => {};
      convertPdfToImages(file).then((url) => {
        let img = document.createElement('img');
        const sizeW = 1296,
          sizeH = 700;

        img.onload = function (event) {
          // Dynamically create a canvas element
          let canvas = document.createElement('canvas');
          canvas.width = sizeW;
          canvas.height = sizeH;

          let ctx = canvas.getContext('2d');

          // Actual resizing
          ctx.drawImage(img, 0, 0, sizeW, sizeH);

          // Show resized image in preview element
          let dataurl = canvas.toDataURL(file.type);

          resolver(dataurl);
          setUploadedFileName(dataurl);
        };
        img.src = url;
      });
      window.console.log = () => {};
    }
  };

  return (
    <>
      <input
        ref={inputRef}
        onChange={handleDisplayFileDetails}
        className="d-none"
        type="file"
      />
      <OverlayTrigger
        placement="top"
        delay={{ show: 100, hide: 100 }}
        overlay={
          <Tooltip id="tooltip-top">{t('upload-button-tooltip')}</Tooltip>
        }
      >
        <button
          disabled={disabled}
          onClick={handleUpload}
          style={{ float: 'left' }}
          className={
            disabled
              ? 'btn btn-outline-primary disabled'
              : 'btn btn-outline-primary'
          }
        >
          <Upload width={16} height={16} />
        </button>
      </OverlayTrigger>
    </>
  );
}

export default UploadButton;
